import { SxProps } from '@mui/material'
import { styled } from '@mui/material/styles'
import LoaderAnimation from './LoaderAnimation'

const RootStyle = styled('div')(({ theme }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))

type Props = {
  sx?: SxProps
}

const AnimatedLogo = ({ ...other }: Props) => {
  return (
    <RootStyle {...other}>
      <LoaderAnimation />
    </RootStyle>
  )
}

export default AnimatedLogo
